import {useEffect} from 'react'
//components
import NoPhoto from '../../../../images/no_property_photo.png'
//styles
import '../../styles/map/map-information-card.css'
const MapInformationCard = ({images,name,place,id}) => {
  
  return (
    <div className='map-information'>
        <div className='map-information__image'>
            {/* IMAGE */}
            {/* <ImagesCarousel images={images}/> */}
           { images ?
              <img src={images} alt=""/>
              :
              <img src={NoPhoto} alt=""/>
           }
        </div>
        <div className='map-information__description'>
            <div className='map-information__description__title'>{name}</div>
            <div className='map-information__description__subtitle'>{place}</div>
            <a href={`/property/dashboard/${id}`} target='_blank'>See Details</a>
        </div>
    </div>
  )
}

export default MapInformationCard